import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { initKvIntro } from '../animation/kv-intro';
import {
  initRevealLines,
  initFadeUp,
  getDelayForViewportEntry,
} from '../animation/scroll-animations';

gsap.registerPlugin(ScrollTrigger, SplitText);

initKvIntro({
  titleSelector: '.js-partners-title',
  subtitleSelector: '.js-partners-subtitle',
});

window.addEventListener('load', () => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initRevealLines();

        [
          '.p-aboutus-partners__logos-logo',
          '.p-aboutus-partners__category',
        ].forEach(selector => {
          gsap.utils.toArray(selector).forEach(el => {
            gsap.set(el, { y: 40, opacity: 0 });
            gsap.to(el, {
              y: 0,
              opacity: 1,
              ease: 'power3.out',
              duration: 0.8,
              delay: getDelayForViewportEntry(el),
              scrollTrigger: {
                trigger: el,
                start: 'top 85%',
                once: true,
              },
            });
          });
        });

        initFadeUp();
        ScrollTrigger.refresh();
      });
    });
  } else {
    ScrollTrigger.refresh();
  }
});
